module.exports = __webpack_public_path__ + "static/footer-b4f284ead7b799c0b845f95c5893628b.png";